export const SHOW_SNACK_BAR = 'SHOW_SNACK_BAR'
export const HIDE_SNACK_BAR = 'HIDE_SNACK_BAR'

export const showSnackbar = (message, severity) => ({
  type: SHOW_SNACK_BAR,
  message,
  severity
})

export const hideSnackbar = () => ({
  type: HIDE_SNACK_BAR
})
